<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <!-- <div calss="form-group row">
            <div class="col-md-6">
                    <h1>REKAPITULACIJA TROŠKOVA - opis</h1>            
            </div>    
    </div>         -->
    <div class="form-group row">       
        <div class="col-md-4">
            <yt-fw-date-picker-popup
                name="txtOdDatuma"
                formControlName="OdDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                [Label]="'REKAPITULACIJATROSKOVA.ODDATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                <span *ngFor="let validation of errorMessages.OdDatuma">
                    <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
        <div class="col-md-4">
            <yt-fw-date-picker-popup
                name="txtDoDatuma"
                formControlName="DoDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                [Label]="'REKAPITULACIJATROSKOVA.DODATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                <span *ngFor="let validation of errorMessages.DoDatuma">
                    <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>    
    <div class="form-group row">
        <div class="col-md-8">
            <yt-multiselect
                [ModelName]="'orgjed'"
                [GetName]="'getParentAndChildByParentID'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                formControlName="OrgJedIDS"
                [AllowAddNew]="false" 
                [Type]="'ID'"
                [Label]="'REKAPITULACIJATROSKOVA.ORGJED.SINGULAR'"                
                [ngClass]="{'is-invalid': submitted && fc.OrgJedIDSinvalid}"
                (GetItems)="SkupiOrgJed($event)"
            >
            </yt-multiselect>
            <div class="form-error" *ngIf="submitted && fc.OrgJedIDS.invalid">
                <span *ngFor="let validation of errorMessages.OrgJedIDS">
                    <span class="error-me ssage" *ngIf="fc.OrgJedIDS.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div> 
    <div class="form-group row">
        <div class="col-md-8">
          <yt-multiselect
                        [ModelName]="'komitent'"
                        [GetName]="'get'"
                        [ModelProperty]="'SNaziv'"
                        [OrderBy]="'SNaziv'"
                        formControlName="KomitentID"
                        [AllowAddNew]="false" 
                        [Type]="'ID'"
                        [Label]="'REKAPITULACIJATROSKOVA.KOMITENTNAZIV.SINGULAR'"
                        [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}"
                        >
           </yt-multiselect>
           <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
            <span *ngFor="let validation of errorMessages.KomitentID">
              <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.KomitentID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
    <div class="form-group row">
        <div class="col-md-8">
            <yt-multiselect
                [ModelName]="'fakvrstatroska'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                formControlName="VrstaTroska"
                [AllowAddNew]="false" 
                [Type]="'ID'"
                [Label]="'REKAPITULACIJATROSKOVA.VRSTATROSKA.SINGULAR'"
                [ngClass]="{'is-invalid': submitted && fc.VrstaTroska.invalid}"
            >
            </yt-multiselect>
            <div class="form-error" *ngIf="submitted && fc.VrstaTroska.invalid">
                <span *ngFor="let validation of errorMessages.VrstaTroska">
                    <span class="error-message" *ngIf="fc.VrstaTroska.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-4">
            <cascade-dropdown
              [ModelName]="'commonString'"
              [ModelProperty]="'Name'"
              [Source]="source"
              formControlName="SortBy"
              [Label]="'REKAPITULACIJATROSKOVA.SORTIRANJE.SINGULAR'"
              (OnItemSelected)="SortByItemSelected($event)">
            </cascade-dropdown>
            <div class="form-error" *ngIf="submitted && fc.SortBy.invalid">
              <span *ngFor="let validation of errorMessages.SortBy">
            <span class="error-message" *ngIf="fc.SortBy.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
          </div>
      </div>
          <div class="form-group row">        
              <div class="col-md-4">
                <yt-dropdown-picklist 
                  [ModelName]="'commonString'"                          
                  [ModelProperty]="'Name'"                  
                  formControlName="AnaSin"                                  
                  [Label]="''"                
                  [Position]="'left'"
                  [AllowAddNew]="false" 
                  [Source]="AnaSinOP"
                  [Disabled]=true >
                </yt-dropdown-picklist >    
                <div class="form-error" *ngIf="submitted && fc.AnaSin.invalid">
                    <span *ngFor="let validation of errorMessages.AnaSin">
                  <span class="error-message" *ngIf="fc.AnaSin.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
              </div>
          </div> 
        <div class="row">
            <div class="col-md-12">
                <button type="button" class="btn btn-primary" (click)="LoadPDF()">Štampaj izveštaj</button>
            </div>
        </div>
</form>
